am4core.ready(function() {

// Themes begin
    am4core.useTheme(am4themes_animated);
// Themes end

    var chart = am4core.create("chart-recalls", am4charts.XYChart);

    var categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.renderer.labels.template.fill = am4core.color("#999999");
    categoryAxis.renderer.labels.template.fontSize = '14px';
    categoryAxis.renderer.labels.template.fontWeight = 'bold';

    categoryAxis.dataFields.category = "type";
    categoryAxis.renderer.minGridDistance = 1;
    categoryAxis.renderer.inversed = true;
    categoryAxis.renderer.grid.template.disabled = true;
    categoryAxis.title.text = 'Year';

    var valueAxis = chart.xAxes.push(new am4charts.ValueAxis());

    valueAxis.title.text = "Number of Recalls";
    valueAxis.min = 0;

    var series = chart.series.push(new am4charts.ColumnSeries());
    series.dataFields.categoryY = "type";
    series.dataFields.valueX = "dataNumber";
    series.tooltipText = "{valueX.value}"
    series.columns.template.strokeOpacity = 0;
    series.columns.template.column.cornerRadiusBottomRight = 5;
    series.columns.template.column.cornerRadiusTopRight = 5;
    series.columns.template.column.fill = '#00AFDB';

    var labelBullet = series.bullets.push(new am4charts.LabelBullet())
    labelBullet.label.text = "{valueX.value}";
    labelBullet.label.horizontalCenter = "right";
    labelBullet.label.dx = -10;
    labelBullet.label.fill = '#FFFFFF';
    labelBullet.label.fontSize = '15px'
    labelBullet.label.fontWeight = 'bold'

// as by default columns of the same series are of the same color, we add adapter which takes colors from chart.colors color set

    chart.data = window.dataRecallsChart;

}); // end am4core.ready()

//form change
$('.make-btn-radio, .vin-btn-radio').click(function(e) {
    let clickEl = $(e.target);

    if ( !clickEl.hasClass( "active" ) ){
        $('.make-btn-radio, .vin-btn-radio').removeClass('active')
        $('.'+clickEl.attr('class').split(/\s+/)[0]).addClass('active')

        let target = 'recall-form-'+$(e.target).data("open")
        $('.recall-form-vin').addClass('d-none')
        $('.recall-form-make-model').addClass('d-none')
        $('.'+target).removeClass('d-none')
    }
});

function runAjax(loadUrl, data, successCallback) {
    $.ajax({
        type: 'POST',
        url: loadUrl,
        data: data,
        dataType: 'html',
        success: function (response) {
            successCallback(response);
        },
        error: function (message) { // if error occured
            console.log(message);
        }
    });
}

document.addEventListener("DOMContentLoaded", function(event) {
    let successCallback = (res, el = '')=>{
        let arr = JSON.parse(res);
        let select = el.next().next('select')
        if (arr.modelsHtmlArr.length){
            select.html( arr.modelsHtmlArr.join('') );
            select.prop('disabled', false);
        } else {
            select.html( '<option selected="selected" value="">Model</option>' );
            select.prop('disabled', true);
        }
    }

    $('.code-input[name="make"]').change(function(e) {
        runAjax('/recalls-get-models', {make : $(e.target).val()}, (res) => successCallback(res, $(e.target)))
    });

});

class RecallsForm {
    constructor(className, searchBlockId, options = {}) {
        this.className = className;
        this.resultSearchBlockId = searchBlockId;
        this.loadUrl = options.sendUrl;
        this.nameArr = options.nameArr;

        this.init();
    }

    init() {
        let el = document.querySelectorAll(`${this.className}`);

        for (let i = 0; i < el.length; i++) {
            el[i].addEventListener('submit', (e) => {
                this.handlerSubmitFunction(e)
            })
        }
    }

    handlerSubmitFunction(e) {
        e.preventDefault();
        window.appClassVinForm = this;
        this.formData = e.currentTarget
        this.startLoading()

        grecaptcha.ready(() => {
            grecaptcha.execute(window.recaptchaSiteKeyCode, {action: '/decoder'}).then(function (token) {
                window.appClassVinForm.send(token)
            });
        });
    }

    send(token) {
        let data = { recaptcha_response: token };

        this.nameArr.forEach(element => {
            data[element] = this.formData.elements[element].value;
        });

        function successCallback(response) {
            let res = JSON.parse(response);

            if (res.html) {
                let searchBlock = document.getElementById(this.resultSearchBlockId)
                searchBlock.innerHTML = res.html;
                searchBlock.scrollIntoView({behavior: 'smooth'})
                this.stopLoading()
            }else{
                this.addErrorsToForm(res.message)
                this.stopLoading()
            }
        }

        this.runAjax(this.loadUrl , data, successCallback.bind(this))
    }

    runAjax(loadUrl, data, successCallback) {
        $.ajax({
            type: 'POST',
            url: loadUrl,
            data: data,
            dataType: 'html',
            success: function (response) {
                successCallback(response);
            },
            error: function (message) { // if error occured
                console.log(message);
            }
        });

    }

    addErrorsToForm(message) {
        let er = $(this.formData.firstElementChild)
        er.find('.error-text').text(message);
        er.find('.form-recall').addClass('errors');

        setTimeout(this.clearErrorsToForm.bind(this), 2500);
    }

    clearErrorsToForm() {
        $(this.formData.firstElementChild).find('.error-text').text('')
        $(this.formData.firstElementChild).find('.form-recall').removeClass('errors')
    }

    startLoading() {
        $(this.formData.firstElementChild).find('.loader1212decoder').removeClass('d-none-loader')
        $(this.formData.firstElementChild).find('.btn-submit').prop("disabled", true)
    }

    stopLoading() {
        $(this.formData.firstElementChild).find('.loader1212decoder').addClass('d-none-loader')
        $(this.formData.firstElementChild).find('.btn-submit').prop("disabled", false)
    }

}

new RecallsForm('.recall-form-make-model', 'recall-form-result', {sendUrl: '/recalls-make', nameArr: ['year', 'make', 'model']})

new RecallsForm('.recall-form-vin', 'recall-form-result', {sendUrl: '/recalls-vin', nameArr: ['vin']})
